import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=844aa20c&scoped=true&"
import script from "./MailingList.vue?vue&type=script&lang=js&"
export * from "./MailingList.vue?vue&type=script&lang=js&"
import style0 from "./MailingList.vue?vue&type=style&index=0&id=844aa20c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844aa20c",
  null
  
)

component.options.__file = "MailingList.vue"
export default component.exports